import { render, staticRenderFns } from "./fourthStep.vue?vue&type=template&id=13c92eb5&scoped=true"
import script from "./fourthStep.vue?vue&type=script&lang=js"
export * from "./fourthStep.vue?vue&type=script&lang=js"
import style0 from "./fourthStep.vue?vue&type=style&index=0&id=13c92eb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c92eb5",
  null
  
)

export default component.exports